"use client";
import { jsx as o } from "react/jsx-runtime";
import { createContext as n, useContext as m } from "react";
const e = n(void 0), i = ({ children: t, attachment: r }) => /* @__PURE__ */ o(e.Provider, { value: { attachment: r }, children: t }), u = () => {
  const t = m(e);
  if (!t)
    throw new Error("useAttachmentItem must be used within a AttachmentItemProvider");
  return t;
};
export {
  i as AttachmentItemProvider,
  u as useAttachmentItem
};
